var map = {
	"./cs.json": [
		"./src/locales/cs.json",
		"src_locales_cs_json"
	],
	"./de.json": [
		"./src/locales/de.json",
		"src_locales_de_json"
	],
	"./en.json": [
		"./src/locales/en.json",
		"src_locales_en_json"
	],
	"./es.json": [
		"./src/locales/es.json",
		"src_locales_es_json"
	],
	"./fr.json": [
		"./src/locales/fr.json",
		"src_locales_fr_json"
	],
	"./it.json": [
		"./src/locales/it.json",
		"src_locales_it_json"
	],
	"./pl.json": [
		"./src/locales/pl.json",
		"src_locales_pl_json"
	],
	"./pt.json": [
		"./src/locales/pt.json",
		"src_locales_pt_json"
	],
	"./sk.json": [
		"./src/locales/sk.json",
		"src_locales_sk_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;